{
  "clientError": {
    "title": "很抱歉，遇到问题了！",
    "body": {
      "line1": "请求出现了问题。请查看您是否输入了正确的链接，或在几分钟后尝试刷新页面。"
    }
  },
  "serverError": {
    "title": "系统遇到问题了。",
    "body": {
      "line1": "服务器出现问题了，我们正在加紧维修。您可同时尝试刷新页面或在几分钟后再次访问。您也可以发送电子邮件至 circs@sph.com.sg 让我们的客服人员协助您。"
    }
  },
  "pageNotFound": {
    "title": "很抱歉，网页已不存在了。",
    "body": {
      "line1": "您要访问的页面已不存在。网页可能已被清除或暂时失效。请查看网址是否正确，或尝试返回上一页。"
    }
  }
}
